var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 55,
    viewBox: "0 0 52 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.916 54.0064V53.2705H50.765V46.1025H51.4681V54.0064H43.916Z",
    fill: "#2965FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000192165 46.1045L0.703265 46.1045L0.703264 53.2688L7.55566 53.2688L7.55566 54.0043L-0.000192495 54.0043L-0.000192165 46.1045Z",
    fill: "#2965FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1362 25.8041H12.2367V21.3877H10.1272V23.5958H8.01758V25.8037H10.1272H8.01758V32.4282H10.1272H12.3402V30.2202H10.1272V28.012H24.2715V42.9239H26.381V25.8041H25.1362Z",
    fill: "#2965FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.016 21.3877H3.79688V23.5954H8.016V21.3877Z",
    fill: "#2965FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2719 23.5957H20.0527V25.8036H24.2719V23.5957Z",
    fill: "#2965FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0511 21.3877H15.832V23.5954H20.0511V21.3877Z",
    fill: "#2965FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1622 9.16699H20.0527V13.1121H22.1622V9.16699Z",
    fill: "#2965FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1456 6.91016H24.0361V11.3742H26.1456V6.91016Z",
    fill: "#2965FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4895 23.5957H26.3799V25.8036H28.4895V23.5957Z",
    fill: "#2965FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6751 25.5869H30.5654V31.414H32.6751V25.5869Z",
    fill: "#2965FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.38 21.3877H24.2705V23.5954H26.38V21.3877Z",
    fill: "#2965FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.599 21.3876V19.1797H26.3799V21.3876H30.599Z",
    fill: "#2965FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6424 32.4287H30.5615V31.4143H28.4521V37.314H30.5615V34.6364H32.5558V36.8438H34.6655V34.6712H36.752V30.002H34.6424V32.4287Z",
    fill: "#2965FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9718 45.1318H38.8623V47.3396H40.9718V45.1318Z",
    fill: "#2965FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0795 41.0332H19.9697V49.8645H22.0795V45.1318H24.2664V42.9238H22.0795V41.0332Z",
    fill: "#2965FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0668 34.5449H3.85938V49.5479H18.1936V47.3395H18.1764V36.7531H18.1936V34.5449H16.0668ZM16.0668 47.3392H5.96878V36.7531H16.0668V47.3392Z",
    fill: "#2965FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1927 47.3398H40.9736V49.5478H45.1927V47.3398Z",
    fill: "#2965FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9531 47.364V49.572H35.0627V45.1562H32.9531V47.364Z",
    fill: "#2965FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9796 47.3398H24.2705V49.5478H30.9796V47.3398Z",
    fill: "#2965FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8635 27.7959H36.7539V30.0037H38.8635V27.7959Z",
    fill: "#2965FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9718 25.5869H38.8623V27.7948H40.9718V25.5869Z",
    fill: "#2965FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.832 21.1719H40.5264V23.3798H44.832V21.1719Z",
    fill: "#2965FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8529 30.2555V25.8398H44.7433V28.0476H42.6338V30.2555H46.8529Z",
    fill: "#2965FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.636 30.2559H40.5264V32.4635H42.636V30.2559Z",
    fill: "#2965FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7433 32.4639H42.6338V34.6717H44.7433V32.4639Z",
    fill: "#2965FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7433 41.2947V45.1312H46.8529V38.6408H44.7433V36.8789H42.6338V41.2947H44.7433Z",
    fill: "#2965FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7568 40.7162H30.9814V42.9244H36.7568V45.1319H38.8664V36.8797H42.6359V34.6719H36.7568V40.7162Z",
    fill: "#2965FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9795 42.9238H26.3799V45.1316H30.9795V42.9238Z",
    fill: "#2965FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7705 30.123V32.4282H19.9732V36.8439H22.0828V32.4278H19.9732V30.123H17.7705Z",
    fill: "#2965FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1795 38.7432H7.86816V45.3487H14.1795V38.7432Z",
    fill: "#2965FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0668 19.1795H18.1936V16.9718H18.1764V6.38583H18.1936V4.17773H3.85938V19.1795H16.0668ZM5.96878 6.38583H16.0668V16.9722H5.96878V6.38583Z",
    fill: "#2965FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1795 8.375H7.86816V14.9805H14.1795V8.375Z",
    fill: "#2965FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.088 6.38583V4.17773H32.7536V9.16768H28.1561V11.3756H26.1505V14.8503H24.2719V13.1129H22.1623V14.8503H20.0527V21.3888H22.1623V17.0584H28.2601V11.3756H32.7536V19.1795H36.7564V23.3793H32.6928V25.5872H38.866V19.1795H47.0879V16.9718H47.0705V6.38583H47.088ZM44.961 16.9722H34.8634V6.38583H44.9614L44.961 16.9722Z",
    fill: "#2965FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.075 8.375H36.7637V14.9805H43.075V8.375Z",
    fill: "#2965FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.468 7.90372H50.765V0.735749H43.916V0H51.468V7.90372Z",
    fill: "#2965FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56951 0V0.735643H0.720581V7.90361H0.0175781V0H7.56951Z",
    fill: "#2965FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.48af1ffdfea40db7160c945f8fe0f3f4.svg";
export { ForwardRef as ReactComponent };